import { render } from "./MaskInput.vue?vue&type=template&id=079fce89"
import script from "./MaskInput.vue?vue&type=script&lang=js"
export * from "./MaskInput.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__